import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TegelModule } from '@scania/tegel-angular-17';
import { DeskPopoverComponent } from '../../desk-popover/desk-popover.component';
import { ReservationListComponent } from '../../reservation-list/reservation-list.component';
import { BuildingAdminComponent } from '../../../admin/building-admin/building-admin.component';
import { P2820_DESKS } from '../shared/constants/p28-20.desks';
import { BuildingReservationsBase } from '../shared/reservation-base';

@Component({
  selector: 'app-p28-20',
  imports: [ReservationListComponent, TegelModule, DeskPopoverComponent, CommonModule, BuildingAdminComponent],
  templateUrl: './p28-20.component.html',
  styleUrl: './p28-20.component.scss'
})
export class P2820Component extends BuildingReservationsBase {
  public readonly desks = P2820_DESKS;
}
